import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useSuspenseQuery as t } from "@maat/store-hooks";
import { listingsApi as n } from "@maat/api-main";
//#region src/properties/useListingDetailQuery.ts
var r = (r) => t({
	queryKey: e.listing(r),
	queryFn: () => n.getListingDetail(r)
});
//#endregion
export { r as useListingDetailQuery };
